import { defineStore } from 'pinia';
import axios from '@/services/axios';

const storageLink = process.env.VUE_APP_STORAGE_BASE_URL;
import userIconPlaceholder from '@/assets/images/user-placeholder.png'
import { useCartStore } from './cart';
import { bootIntercom, shutdownIntercom } from '@/plugins/intercom';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        userinfo: null,
        token: localStorage.getItem('token') || null,
    }),
    actions: {
        async login(email, password) {
            const response = await axios.post('/login', { email, password });

            this.token = response.data.token;
            const user = response.data.user;

            const profilePicture = (user?.profile_picture) ? `${storageLink}${user.profile_picture}` : userIconPlaceholder;

            this.user = {
                name: user?.name,
                firstname: user?.firstname,
                lastname: user?.lastname,
                profilePicture
            };

            user.profilePicture = profilePicture;

            this.userinfo = user;

            localStorage.setItem('token', this.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;

            if (process.env?.VUE_APP_MODE === 'production') {
                bootIntercom({
                    user_id: user.id,
                    name: user.name,
                    email: user.email,
                    createdAt: user.created_at
                });
            }
        },

        async googleLogin(token) {
            this.token = token;
            localStorage.setItem('token', this.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
         
            this.fetchUser();
        },

        async logout(api = true) {
            if (process.env?.VUE_APP_MODE === 'production') {
                shutdownIntercom();
            }
                
            if(api) {
                await axios.post('/logout');
            }
            
            this.token = null;
            this.user = null;
            this.userinfo = null;
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];

            const cartStore = useCartStore();
            cartStore.clearCartLocalStorage();          
        },

        async fetchUser() {
            if (!this.token) return;

            axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;

            try {
                const { data } = await axios.get('/user');
                const user = data.data;

                const profilePicture = (user?.profile_picture) ? `${storageLink}${user.profile_picture}` : userIconPlaceholder;

                this.user = {
                    name: user?.name,
                    firstname: user?.firstname,
                    lastname: user?.lastname,
                    profilePicture
                };

                user.profilePicture = profilePicture;

                this.userinfo = user;

                if (process.env?.VUE_APP_MODE === 'production') {
                    bootIntercom({
                        user_id: user.id,
                        name: user.name,
                        email: user.email,
                        createdAt: user.created_at
                    });
                }
            } catch (error) {
                if (process.env?.VUE_APP_MODE === 'production') {
                    shutdownIntercom();
                }
                
                this.logout(false); // Token is invalid or expired
            }
        },

        initialize() {
            // Called on app startup to restore token and fetch user
            if (this.token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
                this.fetchUser();
            }
        },
        reset() {
            this.$reset(); // ✅ resets state to default
            localStorage.removeItem('token');
        }
    },
    getters: {
        isLoggedIn: (state) => !!state.token,
        role: (state) => state.userinfo?.role ?? null
    }
});